import { CalendarPage as CalendarFeaturePage } from '@/features/garage/components/CalendarPage';

export function CalendarPage(): JSX.Element {
  return <CalendarFeaturePage />;
}
